import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { E_ROUTE_COMMON } from '@/router/routes/route.types';
import { Symbols } from '../symbols';
import _ from 'lodash';
let NavgationService = class NavgationService {
    constructor(router, systemService) {
        this.router = router;
        this.systemService = systemService;
        this.getAccountUrl = (id) => {
            return this.router.resolve({
                name: 'account-next',
                params: {
                    id,
                },
            }).href;
        };
    }
    defineRedirectUri() {
        return encodeURIComponent(location.hash.replace('#', ''));
    }
    getRedirectUri() {
        return decodeURIComponent(this.router.currentRoute.query?.redirect_uri || '');
    }
    goToLogin(error_code) {
        let redirect_uri = '';
        if (!_.includes([
            E_ROUTE_COMMON.ERROR_403,
            E_ROUTE_COMMON.ERROR_404
        ], this.router.currentRoute.name)) {
            redirect_uri = this.defineRedirectUri();
        }
        this.router.replace({
            name: 'login',
            query: {
                ...error_code ? { error_code } : {},
                ...redirect_uri ? { redirect_uri: this.defineRedirectUri() } : {},
            },
        });
    }
    goToError403() {
        const router = this.router.resolve({
            name: E_ROUTE_COMMON.ERROR_403,
        });
        location.href = router.href;
        // 暂时没什么好方法
        location.reload();
    }
    get CooperativeListUrl() {
        return this.router.resolve({
            name: 'cooperative-company',
        }).href;
    }
    goToAdmin() {
        const href = '/?_ad=1#/admin/accounts';
        return this.systemService.redirectTo(href);
    }
    goToRoot(useReplace = true) {
        const redirect_uri = this.getRedirectUri();
        // 使用router解析的方式，解决了redirect_uri中的特殊字符问题
        if (redirect_uri) {
            return this.router.replace({
                path: redirect_uri,
            });
        }
        if (useReplace) {
            return this.router.replace({ name: 'root' });
        }
        else {
            return this.router.push({ name: 'root' });
        }
    }
};
NavgationService = __decorate([
    injectable(),
    __param(0, inject(Symbols.Router)),
    __param(1, inject(Symbols.SystemService)),
    __metadata("design:paramtypes", [Object, Object])
], NavgationService);
export { NavgationService };
